import { ShieldCheck, Scale, Eye, Target, Lock } from "lucide-react";

const pillars = [
  { icon: ShieldCheck, label: "Segurança jurídica" },
  { icon: Eye, label: "Prevenção de riscos" },
  { icon: Scale, label: "Defesa estratégica" },
  { icon: Target, label: "Soluções eficientes" },
  { icon: Lock, label: "Proteção patrimonial e reputacional" },
];

export default function Experiencia() {
  return (
    <section id="experiencia" className="section bg-white" data-testid="section-experiencia">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        {/* Left content */}
        <div className="lg:col-span-7">
          <p className="eyebrow text-brand-accent mb-6"><span className="thin-rule" />Sobre o escritório</p>
          <h2 className="font-serif text-brand-primary font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Experiência que <em className="text-brand-accent not-italic">gera segurança</em>.
          </h2>
          <div className="mt-8 space-y-5 text-[15px] leading-relaxed text-brand-text/85 max-w-2xl">
            <p>
              Desde 2003, o escritório constrói uma atuação sólida e altamente especializada, baseada
              em confiança, complementaridade técnica e visão estratégica do Direito.
            </p>
            <p>
              Ao longo de mais de duas décadas, consolidou experiência em milhares de processos e
              demandas complexas, desenvolvendo uma atuação consistente em diferentes áreas do
              Direito, sempre com foco em:
            </p>
          </div>

          <ul className="mt-8 grid sm:grid-cols-2 gap-x-8 gap-y-4">
            {pillars.map(({ icon: Icon, label }) => (
              <li key={label} className="flex items-start gap-3 text-[14px] text-brand-primary">
                <Icon size={18} className="text-brand-accent mt-1 flex-shrink-0" strokeWidth={1.6} />
                <span className="font-medium">{label}</span>
              </li>
            ))}
          </ul>

          <p className="mt-10 text-[15px] leading-relaxed text-brand-text/85 max-w-2xl">
            A combinação entre experiência prática, atualização acadêmica constante e visão
            estratégica permite ao escritório oferecer uma advocacia preparada para os desafios
            contemporâneos de pessoas e empresas.
          </p>
        </div>

        {/* Right stat block + image */}
        <aside className="lg:col-span-5">
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=900&q=80"
              alt="Ambiente corporativo sofisticado"
              className="w-full h-[420px] lg:h-[520px] object-cover"
            />
            <div className="absolute -bottom-10 -left-10 bg-brand-primary text-white p-8 lg:p-10 w-[260px] hidden md:block">
              <p className="font-serif text-6xl lg:text-7xl leading-none">20+</p>
              <p className="mt-3 text-[11px] tracking-[0.22em] uppercase text-brand-accent">
                Anos de atuação consistente
              </p>
              <div className="mt-6 h-px w-12 bg-brand-accent" />
              <p className="mt-4 text-xs text-white/70 leading-relaxed">
                Milhares de processos e demandas complexas conduzidos com excelência técnica.
              </p>
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}
